import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-900 font-heading font-bold text-lg mb-3 whitespace-nowrap"
            >
              <i className="ri-shield-keyhole-line text-xl text-primary-500"></i>
              <span>暗网91安全指南</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              致力于为中文用户提供暗网安全知识、访问教程与隐私保护指南，帮助用户安全、合规地了解深网世界。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-3 text-sm">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-2"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-3 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/access-tutorial"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200"
                >
                  访问教程
                </Link>
              </li>
              <li>
                <Link
                  to="/category/security-guide"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200"
                >
                  安全指南
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-3 text-sm">
              安全提示
            </h4>
            <div className="flex items-start gap-2 p-3 rounded-lg bg-accent-50 border border-accent-200/50">
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-alert-line text-accent-600"></i>
              </span>
              <p className="text-xs text-foreground-600 leading-relaxed">
                本网站仅供安全知识学习与研究参考。请遵守当地法律法规，切勿将所学知识用于任何非法活动。保护自己，远离风险。
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 暗网91安全指南. 本站内容仅供学习研究，请遵守当地法律法规。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-400 hover:text-primary-600 transition-colors duration-200"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-400 hover:text-primary-600 transition-colors duration-200"
              rel="nofollow"
            >
              使用条款
            </a>
            <a
              href="#"
              className="text-xs text-foreground-400 hover:text-primary-600 transition-colors duration-200"
              rel="nofollow"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}